// hooks/useReservations.js
import { useState, useEffect } from "react";
import { collection, query, where, onSnapshot, orderBy } from "firebase/firestore";
import { db } from "../firebase"; // Corrected: Removed unnecessary curly braces
import useAuth from "./useAuth";
import { getAvailableTimeSlots, createBooking, cancelBooking, addAvailableTimeSlot } from "../utils/api";
import dateFormatter from "../utils/dateFormatter";

// Hem named export hem default export olarak dışa aktarıyoruz
export const useReservations = () => {
  const [reservations, setReservations] = useState([]);
  const [availableTimeSlots, setAvailableTimeSlots] = useState([]);
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();

  const fetchAvailableTimeSlots = async (date) => {
    try {
      const formattedDate = dateFormatter(date)
      const slots = await getAvailableTimeSlots(formattedDate);
      setAvailableTimeSlots(slots);
    } catch (error) {
      console.error("Error fetching available time slots:", error);
    }
  };

  // SEAM entegrasyonlu rezervasyon oluştur
  const createNewReservation = async (date, startTime, endTime, roomId = "music-room") => {
    setLoading(true);
    try {
      // Tarih formatını string'e çevir (YYYY-MM-DD)
      const dateString = date instanceof Date 
        ? date.toISOString().split('T')[0]
        : date;
      
      const result = await createBooking({
        date: dateString,
        startTime,
        endTime,
        roomId
      });
      
      // Başarılı sonuç döner: { success, reservationId, pin, accessCodeId, startsAt, endsAt, message }
      return result;
    } catch (error) {
      console.error("Error creating new reservation:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  // SEAM entegrasyonlu rezervasyon iptali
  const cancelReservation = async (reservationId) => {
    setLoading(true);
    try {
      const result = await cancelBooking(reservationId);
      return result;
    } catch (error) {
      console.error("Error canceling reservation:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  // NOT: fetchAccessCode kaldırıldı - PIN bilgisi artık direkt rezervasyon objesinden okunuyor
  // Rezervasyon objesi şu alanları içerir: pin, pinStatus, pinStartsAt, pinEndsAt

  const addNewAvailableSlot = async (date, startTime, endTime) => {
    try {
      const formattedDate = dateFormatter(date)
      await addAvailableTimeSlot(formattedDate, startTime, endTime);
    } catch (error) {
      console.error("Error creating new slot:", error);
      throw error; // Re-throw the error to be handled by the caller
    }
  };

  // Real-time listener for reservations
  useEffect(() => {
    let unsubscribe = () => {};
    if (!user) {
      setReservations([]);
      return;
    }

    setLoading(true);

    const q = query(
      collection(db, "reservations"), 
      where("userId", "==", user.uid)
    );

    unsubscribe = onSnapshot(q, (snapshot) => {
      const fetchedReservations = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      
      // Client-side sorting ve filtering
      const sortedReservations = fetchedReservations
        .filter(r => r.status !== 'cancelled') // İptal edilmemişleri filtrele
        .sort((a, b) => {
          const dateA = a.date?.toDate?.() || new Date(a.dateString);
          const dateB = b.date?.toDate?.() || new Date(b.dateString);
          return dateB - dateA; // En yeni en üstte
        });
      
      console.log('Fetched reservations:', sortedReservations);
      setReservations(sortedReservations);
      setLoading(false);
    }, (error) => {
      console.error("Error fetching reservations:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [user]);

  return {
    reservations,
    bookings: reservations, // Alias for backwards compatibility
    availableTimeSlots,
    loading,
    fetchAvailableTimeSlots,
    createNewReservation,
    cancelReservation,
    addNewAvailableSlot,
    getAvailableTimeSlots: fetchAvailableTimeSlots, // Alias
  };
};

// Default export da ekliyoruz
export default useReservations;